import React, { Component } from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import {
  Button,
  Input,
  message,
  Modal,
  PageHeader,
  Select,
  Switch,
  Table,
  Tooltip,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { superAdminAction } from "../../_actions/superadmin.action";
import { adminService } from "../../_services/admin.service";

const { Option } = Select;

class DemoCctnsDistricts extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    loading: false,
    searchText: "",
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
    secondaryOpen: false,
    secondaryRecord: null,
    selectedPoliceStation: undefined,
    secondaryLoading: false,
    policeStations: [],
    policeStationLoading: false,
    policeStationSearch: "",
  };

  getCctvDistricts = () => {
    this.setState({ loading: true });
    superAdminAction
      .getCctvDistricts()
      .then((res) => {
        this.setState({
          data: res.data || [],
          loading: false,
        });
      })
      .catch(() => {
        message.error("Failed to load CCTNS districts");
        this.setState({ loading: false });
      });
  };

  getCctvDistrictsCity = () => {
    this.setState({ loading: true });
    const { user } = this.props;
    adminService
      .getCctvDistrictsCity({ city: user.cityId })
      .then((res) => {
        this.setState({
          data: res.data || [],
          loading: false,
        });
      })
      .catch(() => {
        message.error("Failed to load CCTNS districts");
        this.setState({ loading: false });
      });
  };
  componentDidMount = () => {
    const { user } = this.props;
    if (user.role === "4") {
      this.getCctvDistrictsCity();
    } else {
      this.getCctvDistricts();
    }
  };

  updateCctvDistrict = (record) => {
    console.log("record_name", record);
    console.log("this.props.use", this.props.user);
    if (this.props.user.role === "4") {
      const payload = {
        cctnspsid: record.districtId,
        district_name: record.districtName,
        cityId: this.props.user.cityId,
      };
      console.log("payload", payload);
      adminService
        .addCctnsDistrict(payload)
        .then(() => {
          message.success("Updated Successfully");
          this.getCctvDistrictsCity();
        })
        .catch(() => {
          message.error("Update failed");
        });
    } else {
      const payload = {
        cctnspsid: record.cctnspsid,
        district_name: record.DistrictName,
        cityId: record.CityId,
      };
      superAdminAction
        .updateCctvDistrict(payload)
        .then(() => {
          message.success("Updated Successfully");
          this.setState((prevState) => ({
            data: prevState.data.map((item) =>
              item.cctnspsid === record.cctnspsid
                ? { ...item, is_map: true }
                : item,
            ),
          }));
        })
        .catch(() => {
          message.error("Update failed");
        });
    }
  };

  handleStatusToggle = (record) => {
    if (record.is_map) {
      return;
    }
    this.updateCctvDistrict(record);
  };

  getRecordId = (record) => record?.cctnspsid || record?.districtId;

  getDistrictName = (record) =>
    record?.DistrictName || record?.districtName || "-";

  loadPoliceStations = () => {
    this.setState({ policeStationLoading: true });
    superAdminAction
      .getCctnsMissingPoliceStations()
      .then((res) => {
        const policeStations = (res.data || [])
          .map((item) => item.police_station)
          .filter(Boolean);
        this.setState({
          policeStations,
          policeStationLoading: false,
        });
      })
      .catch(() => {
        message.error("Failed to load police stations");
        this.setState({ policeStationLoading: false });
      });
  };

  openSecondaryModal = (record) => {
    this.setState({
      secondaryOpen: true,
      secondaryRecord: record,
      selectedPoliceStation: record.secondary_name || undefined,
      policeStationSearch: "",
    });
    if (!this.state.policeStations.length) {
      this.loadPoliceStations();
    }
  };

  closeSecondaryModal = () => {
    this.setState({
      secondaryOpen: false,
      secondaryRecord: null,
      selectedPoliceStation: undefined,
      secondaryLoading: false,
      policeStationSearch: "",
    });
  };

  updateSecondaryName = () => {
    const { secondaryRecord, selectedPoliceStation } = this.state;
    const cctnspsid = this.getRecordId(secondaryRecord);

    if (!selectedPoliceStation) {
      message.warning("Please select a police station");
      return;
    }

    this.setState({ secondaryLoading: true });
    superAdminAction
      .updateCctnsDistrictSecondaryName({
        cctnspsid,
        secondary_name: selectedPoliceStation,
      })
      .then(() => {
        message.success("Secondary name updated successfully");
        this.setState((prevState) => ({
          secondaryOpen: false,
          secondaryRecord: null,
          selectedPoliceStation: undefined,
          secondaryLoading: false,
          data: prevState.data.map((item) =>
            this.getRecordId(item) === cctnspsid
              ? { ...item, secondary_name: selectedPoliceStation }
              : item,
          ),
        }));
      })
      .catch((err) => {
        message.error(err || "Update failed");
        this.setState({ secondaryLoading: false });
      });
  };

  handleTableChange = (pagination) => {
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        ...pagination,
      },
    }));
  };
  getFilteredData = () => {
    const { data, searchText } = this.state;
    const query = searchText.trim().toLowerCase();

    if (!query) {
      return data;
    }

    return data.filter((item) => {
      const stateName = (item.state || "").toLowerCase();
      const statusText = item.is_active ? "active" : "inactive";
      return stateName.includes(query) || statusText.includes(query);
    });
  };

  render() {
    const { loading, searchText, pagination, data } = this.state;
    const { t } = this.context;
    const filteredData = this.getFilteredData();
    const { user } = this.props;

    const columns =
      user.role === "4"
        ? [
            {
              title: t("sr.no"),
              dataIndex: "srNo",
              key: "srNo",
              render: (_, __, rowIndex) =>
                (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
            },
            {
              title: "DistrictName",
              dataIndex: "districtName",
              key: "districtName",
              render: (text, record) => (
                <Tooltip title={record.districtId}>
                  <span>{record.districtName}</span>
                </Tooltip>
              ),
            },
            {
              title: "Status",
              dataIndex: "is_map",
              key: "is_map",
              render: (is_active) => (is_active ? "Mapped" : "Not Mapped"),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) => (
                <Switch
                  checked={!!record.is_map}
                  checkedChildren="Mapped"
                  unCheckedChildren="Not Mapped"
                  onChange={() => this.handleStatusToggle(record)}
                  disabled={record.is_map === true}
                />
              ),
            },
            {
              title: "Secondary Name",
              key: "secondary_name",
              render: (text, record) => (
                <Button
                  type="primary"
                  onClick={() => this.openSecondaryModal(record)}
                >
                  Update
                </Button>
              ),
            },
          ]
        : [
            {
              title: t("sr.no"),
              dataIndex: "srNo",
              key: "srNo",
              render: (_, __, rowIndex) =>
                (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
            },
            {
              title: "Cctnspsid",
              dataIndex: "cctnspsid",
              key: "cctnspsid",
            },
            {
              title: "Cctns policestation",
              dataIndex: "cctnspolicestation",
              key: "cctnspolicestation",
            },
            {
              title: "DistrictName",
              dataIndex: "DistrictName",
              key: "DistrictName",
            },
            {
              title: "City Name",
              dataIndex: "City",
              key: "City",
            },
            {
              title: "Status",
              dataIndex: "is_map",
              key: "is_map",
              render: (is_active) => (is_active ? "Mapped" : "Not Mapped"),
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              render: (text, record) => (
                <Switch
                  checked={!!record.is_map}
                  checkedChildren="Mapped"
                  unCheckedChildren="Not Mapped"
                  onChange={() => this.handleStatusToggle(record)}
                />
              ),
            },
            {
              title: "Secondary Name",
              key: "secondary_name_admin",
              render: (text, record) => (
                <Button
                  type="primary"
                  onClick={() => this.openSecondaryModal(record)}
                >
                  Update
                </Button>
              ),
            },
          ];
    return (
      <>
        <div
          className="site-page-header-ghost-wrapper"
          style={{
            padding: "20px",
            background: "#fff",
            marginBottom: "20px",
          }}
        >
          <PageHeader
            title={
              this.props.user.role === "4"
                ? "Map Police Station"
                : "CCTNS Police station map"
            }
          />
          <Table
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={filteredData}
            rowKey={(record) => record.id ?? record.cctnspsid}
            rowClassName={() => "govt-table-row"}
            pagination={{
              ...pagination,
              total: data.length,
              showTotal: (total) => `Total ${total} states`,
            }}
            onChange={this.handleTableChange}
          />
          <Modal
            title="Secondary Name"
            visible={this.state.secondaryOpen}
            onCancel={this.closeSecondaryModal}
            onOk={this.updateSecondaryName}
            confirmLoading={this.state.secondaryLoading}
            okText="Update"
            destroyOnClose
            centered
            bodyStyle={{ overflow: "visible", minHeight: 280 }}
          >
            <div style={{ marginBottom: 16 }}>
              <strong>CMIS District Name</strong>
              <div>{this.getDistrictName(this.state.secondaryRecord)}</div>
            </div>
            <div style={{ position: "relative" }}>
              <Select
                showSearch
                allowClear
                style={{ width: "100%" }}
                placeholder="Search police station"
                value={this.state.selectedPoliceStation}
                loading={this.state.policeStationLoading}
                searchValue={this.state.policeStationSearch}
                onSearch={(value) =>
                  this.setState({ policeStationSearch: value })
                }
                onChange={(value) =>
                  this.setState({
                    selectedPoliceStation: value,
                    policeStationSearch: "",
                  })
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                dropdownMatchSelectWidth
                listHeight={220}
                filterOption={(input, option) =>
                  String(option?.value ?? option?.children ?? "")
                    .toLowerCase()
                    .includes(String(input || "").toLowerCase())
                }
                dropdownRender={(menu) => (
                  <div>
                    <div
                      style={{ padding: 8 }}
                      onMouseDown={(event) => event.preventDefault()}
                    >
                      <Input
                        allowClear
                        placeholder="Search police station"
                        value={this.state.policeStationSearch}
                        onChange={(event) =>
                          this.setState({
                            policeStationSearch: event.target.value,
                          })
                        }
                      />
                    </div>
                    {menu}
                  </div>
                )}
              >
                {this.state.policeStations.map((station) => (
                  <Option key={station} value={station}>
                    {station}
                  </Option>
                ))}
              </Select>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedCctnsDistricts = connect(mapStateToProps)(DemoCctnsDistricts);
export { connectedCctnsDistricts as CctnsDistricts };
